/**
 * Factory for creating an interceptor that amends the outgoing request by
 * adding an additional header
 */ export var headerInterceptorFactory = function() {
    for(var _len = arguments.length, header = new Array(_len), _key = 0; _key < _len; _key++){
        header[_key] = arguments[_key];
    }
    return function(config) {
        var headers = config.headers || (config.headers = {});
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = header[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var h = _step.value;
                if (typeof h.value === "string") {
                    headers[h.header] = h.value;
                } else {
                    var value = h.value();
                    if (value) {
                        headers[h.header] = value;
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return config;
    };
};
